import { PouchDBService } from '../pouchdb.service';

export class EntityIndexesInitialized {
    private static isInstantiated: boolean;

    constructor() {}

    static initialize(dbEntities: any) {
        const pouchDB: PouchDBService = new PouchDBService();
        if (!EntityIndexesInitialized.isInstantiated) {
            for (const entity of dbEntities) {
                if (entity.prototype.getIndexes) {
                    for (const indexEntity of entity.prototype.getIndexes()) {
                        pouchDB.createIndexFromEntity(indexEntity).subscribe(
                            (result) => {
                                console.log(
                                    `PouchDB: Index creation successfull for ${entity.name} - ${indexEntity.name}`
                                );
                            },
                            (error) => {
                                // console.log('Error' + error);
                            }
                        );
                    }
                }
            }
            EntityIndexesInitialized.isInstantiated = true;
        }
    }
}
